// src/components/GoogleMapsOverlay.js
import React from 'react';

const GoogleMapsOverlay = ({ center, zoom = 18 }) => {
  if (!center) return null;

  const [lat, lng] = center;
  const googleMapsApiKey = "AIzaSyCT8RQ0ceKM9Pj9A7HbR2FUhC3JZOJyRh4"; // Replace with your API key

  // Use the "view" embed with satellite imagery.
  const src = `https://www.google.com/maps/embed/v1/view?key=${googleMapsApiKey}&center=${lat},${lng}&zoom=${zoom}&maptype=satellite`;

  const iframeStyle = {
      position: "absolute",
      top: "50%",                   // Position at 50% from the top of the container
      left: "10px",                 // 10px from the left edge (adjust as needed)
      transform: "translateY(-50%)",// Move the element up by half of its height to center it vertically
      width: "300px",
      height: "300px",
      border: "2px solid #ccc",
      zIndex: 1000,                 // Ensure it overlays on top of other elements
      borderRadius: "5px"
};


  return <iframe title="Google Maps Satellite View" style={iframeStyle} src={src} allowFullScreen />;
};

export default GoogleMapsOverlay;
